// extracted by mini-css-extract-plugin
export default {"imageGrid":"imageGrid-Oa6_M"};